import { IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonCol, IonRow } from "@ionic/react";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { translation } from "../models/translation";
import BarChart from "./BarChart";
import PieChart from "./PieChart";

interface Donation {
    acf:{
        beneficiary: string,
        amount: number,
        date: string
    },

}


interface ChartProps {
    data: Donation[],
}

const Chart: React.FC<ChartProps> = (props) => {

    const siteText=translation();

    const data = props.data.map(d=>d.acf)

    const chartWrapper = useRef<HTMLIonColElement>(null);

    const [dimmensions, setDimensions] = useState(
        {
            maxWidth: 0,
            innerRadius: 0,
            actualWidth: 0,
            max: 0,
        }
    );

    const [width, setWidth] = useState(0);

    const updateWidth = () => {
        const el = document.getElementById('chartWrapper')!;
        setWidth(window.innerWidth / 3);
    }

    const getContainerDemension = () => {
        let maxD = findMax(data);
        setDimensions({ maxWidth: width / 4, innerRadius: (width * 0.15), actualWidth: width, max: maxD });

    }

    // find the highest value to scale the 
    const findMax = (data: any) => {
        let maX = 0;
        const a = data.length;

        for (let counter = 0; counter < a; counter++) {
            let item = +data[counter].amount;
            if (item > maX) {
                maX = item;
            }
        }
        return maX;
    }


    useEffect(() => {
        updateWidth()
    }, [])

    useLayoutEffect(() => {
        window.addEventListener("resize", updateWidth);
    }, []);

    useLayoutEffect(() => {
        getContainerDemension();
    }, [width]);



    return (


                <IonRow>
                    <IonCol id="barchartWrapper" sizeXs="12" sizeSm="6">

                        <IonCard>
                        <IonCardHeader>
                            <IonCardTitle>
                                <h3 className="h4">{siteText.accountHomeBarchatTitle}</h3>
                            </IonCardTitle>
                        </IonCardHeader>
                            <IonCardContent>
                            <BarChart data={data} realWidth={dimmensions.actualWidth} outerRadius={dimmensions.actualWidth} siteText={siteText}></BarChart>
                            </IonCardContent>
                        </IonCard>
                    </IonCol>
                    <IonCol id="chartWrapper"    ref={chartWrapper}  sizeXs="12" sizeSm="6">
                        <IonCard>
                            <IonCardHeader>
                                <IonCardTitle>
                        <h3 className="h4">{siteText.accountHomePieChartTitle}</h3>
                                </IonCardTitle>
                            </IonCardHeader>
                            <IonCardContent style={{height:"390px"}}>
                            <PieChart data={data} outerRadius={dimmensions.maxWidth} innerRadius={dimmensions.innerRadius}></PieChart>
                            </IonCardContent>
                        </IonCard>
                    </IonCol>
                </IonRow>



    )
}

export default Chart;

